import { Types } from "common/createjs";
import { Sheet } from "common/sheet";
import { resourcesRoot } from "from-start/scene/resources";
import * as R from "ramda";
import { Background } from "./resources/background";
import { Button } from "./resources/buttons";
import { Hand } from "./resources/hand";
import { Message } from "./resources/message";
import { fileName as soundFileName } from "./resources/sound";
import { Title } from "./resources/title";
export const videoFileName = "3번 앞뒤 영상.mp4";
export function toPath(fileName) {
    return `${resourcesRoot}/3-loveletter/${fileName}`;
}
export const resourcePaths = [
    ...R.compose(R.chain((n) => [`sheet-${n}.png`, `sheet-${n}.json`]), R.range)(0, 10),
    {
        src: soundFileName,
        type: Types.SOUND,
    },
].map((name) => {
    if (typeof name === "string") {
        return toPath(name);
    }
    else {
        return Object.assign(Object.assign({}, name), { src: toPath(name.src) });
    }
});
export async function loadSheets() {
    return await Promise.all(R.compose(R.map((n) => Sheet.load(toPath(`sheet-${n}.png`), toPath(`sheet-${n}.json`))), R.range)(0, 10));
}
export { Background, Button, Message, Title, Hand, soundFileName };
//# sourceMappingURL=resources.js.map